import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinramanujanitcity() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Ramanujan IT City Chennai',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Ramanujan IT City Chennai',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Ramanujan IT City Chennai, catering to the transportation needs of IT companies, corporate offices, and business centers within the IT park. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Ramanujan IT City Chennai.',

    top: 'Top Places to Visit in Ramanujan IT City with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Ramanujan IT Park",
    "description": "Ramanujan IT Park is a major technology and business hub located in [City Name]. It houses several IT and software companies, providing modern office spaces, conference facilities, and landscaped surroundings. The park is designed to foster innovation, collaboration, and productivity, making it a key destination for tech professionals and businesses in the region."
  },
  {
    "title": "Nearby Cafés and Restaurants",
    "description": "The vicinity of Ramanujan IT Park offers a variety of cafés, eateries, and casual dining options catering to IT professionals and visitors. These spaces are popular for quick lunch breaks, business meetings, and evening relaxation, creating a convenient social and culinary environment near the tech park."
  },
  {
    "title": "Corporate Event Spaces",
    "description": "Ramanujan IT Park features dedicated spaces for corporate events, seminars, and workshops. These facilities are equipped with modern technology, seating arrangements, and meeting rooms, supporting professional gatherings and community engagement within the IT ecosystem."
  },
  {
    "title": "Nearby Hotels and Business Accommodation",
    "description": "Several hotels and serviced apartments are located near Ramanujan IT Park, offering convenient lodging for visiting professionals, clients, and tourists. These accommodations provide modern amenities, easy connectivity, and proximity to the IT hub, enhancing the overall business travel experience."
  },
  {
    "title": "Parks and Green Spaces",
    "description": "The areas surrounding Ramanujan IT Park include landscaped gardens, walking paths, and small green zones. These spaces offer employees and visitors a peaceful environment for short breaks, outdoor meetings, and relaxation amidst the busy corporate atmosphere."
  },
  {
    "title": "Shopping and Convenience Centers",
    "description": "Nearby shopping complexes and convenience stores provide essential goods, stationery, and retail services for employees and residents near Ramanujan IT Park. These facilities add to the convenience and accessibility of the area, making daily life easier for the tech park community."
  },
  {
    "title": "Transport Connectivity",
    "description": "Ramanujan IT Park is well-connected by major roads, public transport, and nearby metro or bus stations. Easy accessibility ensures smooth commuting for employees, clients, and visitors, reinforcing the park’s role as a central business and technology hub."
  },
  {
    "title": "Fitness and Wellness Centers",
    "description": "The vicinity includes gyms, yoga studios, and wellness centers catering to IT professionals and residents. These facilities promote a balanced lifestyle, offering fitness programs, wellness workshops, and recreational activities, ideal for post-work relaxation and health maintenance."
  },
  {
    "title": "Nearby Educational Institutions",
    "description": "Several schools, colleges, and training centers are located near Ramanujan IT Park, offering educational opportunities for families and employees residing in the area. These institutions contribute to the overall infrastructure and community development surrounding the tech hub."
  },
  {
    "title": "Networking and Professional Meetups",
    "description": "Ramanujan IT Park hosts occasional networking events, tech meetups, and industry workshops. These gatherings provide opportunities for professional collaboration, skill development, and knowledge sharing among IT professionals, fostering a dynamic and innovative corporate environment."
  }
],


"services": [
{
"name": "Ramanujan IT Park Cab",
"description": "Ramanujan IT Park Cab provides dedicated, tech-enabled corporate cab services for employees, executives, and visitors commuting to Ramanujan IT City. With a managed fleet of sedans, SUVs, and shuttle vans, the service ensures punctual pickups, fixed and flexible routing, multi-shift transport support, and GPS-powered ride monitoring. Designed for IT companies operating in a high-density tech hub, it delivers safe, reliable, and hassle-free daily commuting with professional chauffeurs and seamless coordination across all Ramanujan IT Park zones."
},
{
"name": "Corporate Shuttle Ramanujan City",
"description": "Corporate Shuttle Ramanujan City offers high-capacity shuttle operations for companies managing large-scale workforce movement. Featuring AC minibuses, optimised routes, automated attendance systems, and real-time geo-tracking, the service is built for IT hubs requiring bulk staff transfers. It supports peak-hour movement, multi-shift operations, and zone-to-zone transfers while ensuring orderly, safe, and time-efficient employee mobility across Ramanujan IT City."
},
{
"name": "Employee Pickup Drop Ramanujan IT City",
"description": "Employee Pickup Drop Ramanujan IT City provides structured, pre-planned daily commute arrangements for employees working in Ramanujan IT Park. With fixed routes, real-time tracking, verified chauffeurs, and shift-aligned scheduling, it ensures employees reach their offices safely and on time. The service is ideal for companies requiring dependable, coordinated transport with end-to-end monitoring and high operational consistency."
},
{
"name": "Business Cab Ramanujan",
"description": "Business Cab Ramanujan offers premium corporate travel solutions for meetings, airport transfers, client visits, inter-office trips, and executive mobility. The fleet includes modern sedans and SUVs equipped with comfort features, driven by experienced chauffeurs trained for corporate protocols. With on-demand availability, priority dispatch, and assured punctuality, it caters to professionals seeking a seamless, refined business travel experience."
},
{
"name": "Monthly Transport Ramanujan IT City",
"description": "Monthly Transport Ramanujan IT City delivers long-term, contract-based transportation solutions for companies operating inside the IT park. It includes dedicated vehicles, trained drivers, maintenance support, safety monitoring, and GPS tracking. Ideal for firms requiring consistent daily staff movement, the service assures uninterrupted operations, predictable costs, and fully managed mobility tailored to company requirements."
},
{
"name": "Best Corporate Cab Ramanujan",
"description": "Best Corporate Cab Ramanujan offers premium-grade travel services with top-quality vehicles, expert chauffeurs, and superior safety standards. Suitable for executives, managers, and VIP clients, it provides plush travel comfort, punctual service, and a high-end mobility experience. It covers corporate visits, board meetings, hotel pickups, airport transfers, and more, delivering a polished and reliable travel standard."
},
{
"name": "Affordable Cab Ramanujan",
"description": "Affordable Cab Ramanujan offers cost-effective yet dependable cab services designed for startups, SMEs, and medium-sized IT firms in Ramanujan IT City. With optimized routing, clean vehicles, professional drivers, and transparent pricing, it provides a budget-friendly solution without compromising on safety, punctuality, or comfort for daily employee travel."
},
{
"name": "Outstation Cab Ramanujan",
"description": "Outstation Cab Ramanujan provides long-distance business travel solutions for corporate meetings, intercity client visits, factory tours, and executive road trips. The service includes comfortable sedans and SUVs, experienced chauffeurs, interstate permits, route planning, and live tracking. It ensures safe, convenient, and professionally managed travel for companies needing reliable outstation mobility."
},
{
"name": "Sedan Cab Ramanujan",
"description": "Sedan Cab Ramanujan offers executive-friendly sedans ideal for managerial commute, airport rides, business visits, and everyday premium office travel. Featuring well-maintained interiors, enhanced safety features, and professionally trained drivers, the service ensures a smooth, quiet, and comfortable travel experience that meets corporate expectations."
},
{
"name": "SUV Cab Ramanujan",
"description": "SUV Cab Ramanujan provides spacious, comfortable, and high-performance SUVs suitable for senior executives, team movements, outstation trips, and long corporate drives. The service prioritizes comfort, safety, and reliability with advanced tracking, trained chauffeurs, and high-quality vehicle standards tailored to corporate mobility needs."
},
{
"name": "Company Fleet Ramanujan IT City",
"description": "Company Fleet Ramanujan IT City offers end-to-end fleet outsourcing and management for organizations requiring fully managed transport solutions. With sedans, SUVs, shuttles, and staff cabs, the fleet includes driver management, vehicle maintenance, compliance tracking, GPS monitoring, and customizable transport plans for companies across Ramanujan IT City."
},
{
"name": "Staff Shuttle Ramanujan",
"description": "Staff Shuttle Ramanujan provides streamlined shuttle operations designed for daily workforce transportation. Supported by dedicated coordination teams, smart route optimization, GPS visibility, and safety protocols, it ensures timely, organized, and efficient employee movement. Ideal for companies with medium-to-large staff volumes requiring structured commuting solutions."
},
{
"name": "Office Cab Ramanujan",
"description": "Office Cab Ramanujan offers standardized office pick-up and drop services optimized for IT and corporate employees working inside Ramanujan IT City. The service features pre-scheduled routes, digital monitoring, well-trained chauffeurs, and compliant operations to ensure safe, punctual, and smooth daily transport aligned with shift timings."
},
{
"name": "Corporate Transport Ramanujan",
"description": "Corporate Transport Ramanujan provides comprehensive mobility services including employee commute, executive transfers, business trips, visitor movement, and fleet outsourcing. With high safety standards, trained drivers, modern vehicles, and centralized fleet management, it enables companies to run reliable, scalable, and efficient transport operations across the Ramanujan IT hub."
},
{
"name": "IT Employee Mobility Chennai",
"description": "IT Employee Mobility Chennai offers specialized commute solutions for IT professionals across major tech corridors including Ramanujan IT City. With advanced scheduling software, multi-shift support, safe driving protocols, GPS-enabled tracking, and fleet scalability, it ensures smooth, reliable, and tech-driven mobility tailored to the dynamic needs of Chennai’s IT workforce."
}
],


"tableData": [
["Ramanujan IT Park Cab", "Corporate Shuttle Ramanujan City"],
["Employee Pickup Drop Ramanujan IT City", "Business Cab Ramanujan"],
["Monthly Transport Ramanujan IT City", "Best Corporate Cab Ramanujan"],
["Affordable Cab Ramanujan", "Outstation Cab Ramanujan"],
["Sedan Cab Ramanujan", "SUV Cab Ramanujan"],
["Company Fleet Ramanujan IT City", "Staff Shuttle Ramanujan"],
["Office Cab Ramanujan", "Corporate Transport Ramanujan"],
["IT Employee Mobility Chennai", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Ramanujan IT City Chennai",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides reliable corporate cab services in Ramanujan IT City Chennai, ensuring smooth and efficient transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We guarantee punctual pickups and drop-offs across Ramanujan IT City and nearby IT corridors, helping professionals reach offices and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained chauffeurs deliver safe, courteous, and disciplined travel, ensuring a secure and comfortable commuting experience for corporate staff."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Choose from sedans, SUVs, tempo travellers, and buses—all sanitized, serviced, and maintained for reliable and comfortable corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We offer flexible and tailored cab rental plans to meet the specific commuting needs of companies and employees in Ramanujan IT City Chennai."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team is available 24/7 to manage bookings, emergencies, and travel adjustments, ensuring uninterrupted corporate transportation."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles undergo regular sanitization and are equipped with modern safety features, providing safe, clean, and comfortable rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking process and reliable coordination ensure smooth and hassle-free corporate travel management for HR and admin teams."
  }
]






































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Ramanujan IT City, Chennai?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dedicated and professional corporate cab services for companies located in Ramanujan IT City, Chennai.',
  },
  {
    question: 'What types of transportation services are offered in Ramanujan IT City?',
    answer: 'We provide employee transportation, corporate pickups and drops, last-mile connectivity, shuttle services, and airport transfers for all corporate requirements.',
  },
  {
    question: 'Do you support daily commute services for employees working in Ramanujan IT City?',
    answer: 'Yes, we offer well-structured daily commute services with optimized routes, punctual pickups, and multi-shift transportation support.',
  },
  {
    question: 'How can companies book corporate cab services in Ramanujan IT City?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 dedicated corporate support desk.',
  },
  {
    question: 'What vehicle options do you offer for corporate cab services?',
    answer: 'We offer hatchbacks, sedans, SUVs, Innova Crysta, luxury cars, electric cabs, and tempo travellers based on corporate needs.',
  },
  {
    question: 'Do you provide long-term corporate cab contracts for companies in Ramanujan IT City?',
    answer: 'Yes, we offer monthly, quarterly, and annual corporate transportation contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are your vehicles equipped with safety and tracking systems?',
    answer: 'Yes, all vehicles are GPS-enabled, sanitized regularly, and driven by well-trained and background-verified chauffeurs.',
  },
  {
    question: 'Do you support night shift and rotational shift travel requirements?',
    answer: 'Absolutely. We offer transportation for night shifts, early morning shifts, weekend operations, and rotational employee schedules.',
  },
  {
    question: 'What payment options are available for corporate cab services?',
    answer: 'We accept UPI, bank transfers, corporate invoicing, credit/debit cards, and digital wallet payments.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Arvind Seshadri',
    feedback: 'Excellent service for our office at Ramanujan IT City. Professional drivers and consistently clean vehicles.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Meera Venkatesh',
    feedback: 'Reliable corporate cab partner. Their timely pickups and well-maintained fleet make daily travel seamless for our employees.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Ramanujan IT City Chennai",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-ramanujan-it-city.jpg", // replace with real image URL
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Ramanujan IT City Chennai, offering employee pickup & drop, IT park shuttles, business cabs, monthly corporate transportation, outstation travel, chauffeur-driven cars, and complete corporate fleet solutions for companies operating in Ramanujan IT City.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-ramanujan-it-city-chennai"
  }
};









  return (
    <div>
<Helmet>
  <title>Corporate Cab Service in Ramanujan IT City Chennai | Employee & Business Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Ramanujan IT City Chennai including employee pickup & drop, IT park shuttles, business cabs, monthly corporate transportation, outstation travel, and complete corporate fleet solutions."
  />

  <meta
    name="keywords"
    content="Ramanujan IT Park Cab, Corporate Shuttle Ramanujan City, Employee Pickup Drop Ramanujan IT City, Business Cab Ramanujan, Monthly Transport Ramanujan IT City, Best Corporate Cab Ramanujan, Affordable Cab Ramanujan, Outstation Cab Ramanujan, Sedan Cab Ramanujan, SUV Cab Ramanujan, Company Fleet Ramanujan IT City, Staff Shuttle Ramanujan, Office Cab Ramanujan, Corporate Transport Ramanujan, IT Employee Mobility Chennai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/73.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinramanujanitcity;